import { locale } from '../../common/localization/localizationService';
import moment from 'moment';

export function getWorklistGeneratedName(index) {
  const date = moment();
  const formattedDate = date.format(locale.general._fullMomentFormat);
  return `${formattedDate} - ${locale.routeOptimalizationWizard._worklistOptionText} ${index + 1}`;
}
